/**
 * 活动配置
 */

function mediaQuery(query) {
  return window.matchMedia(query).matches;
}
const activity = {
  homeBannerPc: "/static/img/newhome_img/top_bg.png",
  homeBannerPhone: "/static/img/newhome_img/top_bg.png",
  homeBtnTextColor: "#fff",
  homeBtnColor: "#9C60FC",
  homeBtnGradientColor: ["#fff", "#fff"],
  pcTitleColor: "#fff",
  phoneTitleColor: "#fff",
  homeAwardsColor: "#fff",
  insetBg: "activity/inset",
  logoColor: "#295FFD",
  homeBannerDecorations: [
    {
      // path: '/static/img/mother-day/web_top_mothersday.png',
      getpath: function () {
        let path = "/static/img/newhome_img/top_bg.png";
        if (mediaQuery("(max-width: 767px)")) {
          path = "/static/img/newhome_img/top_bg.png";
        }
        return path;
      },
      getStyle: function () {
        let style = {
          position: "absolute",
          top: ".79rem",
          left: "50%",
          transform: "translateX(-50%)",
          width: "2.95rem",
        };
        if (mediaQuery("(max-width: 767px)")) {
          style.top = ".6rem";
          style.width = "1.47rem";
        }
        return style;
      },
    },
  ],
  mediaQuery,
};
export default activity;



// WEBPACK FOOTER //
// ./src/config/activity.js